import BritishBroadcastingCorporationWEBP from '../src/assets/BrandEndorsementsSectionAssets/bbc.webp'
import EveningStandardPNG from '../src/assets/BrandEndorsementsSectionAssets/eveningstandard.png'
import EveningStandardWEBP from '../src/assets/BrandEndorsementsSectionAssets/eveningstandard.webp'
import IndependentPNG from '../src/assets/BrandEndorsementsSectionAssets/independent.png'
import IndependentWEBP from '../src/assets/BrandEndorsementsSectionAssets/independent.webp'
import MarieClairePNG from '../src/assets/BrandEndorsementsSectionAssets/marieclaire.png'
import MarieClaireWEBP from '../src/assets/BrandEndorsementsSectionAssets/marieclaire.webp'
import TheTelegraphPNG from '../src/assets/BrandEndorsementsSectionAssets/thetelegraph.png'
import TheTelegraphWEBP from '../src/assets/BrandEndorsementsSectionAssets/thetelegraph.webp'
import BritishBroadcastingCorporationPNG from './assets/BrandEndorsementsSectionAssets/bbc.png'

export const BRAND_ENDORSEMENTS = {
  header: 'Tested and loved by',
  images: {
    britishBroadcastingCorporation: {
      png: BritishBroadcastingCorporationPNG,
      webp: BritishBroadcastingCorporationWEBP,
    },
    eveningStandard: {
      png: EveningStandardPNG,
      webp: EveningStandardWEBP,
    },
    independent: {
      png: IndependentPNG,
      webp: IndependentWEBP,
    },
    marieClaire: {
      png: MarieClairePNG,
      webp: MarieClaireWEBP,
    },
    theTelegraph: {
      png: TheTelegraphPNG,
      webp: TheTelegraphWEBP,
    },
  },
}

export const ENDLESS_VARIETY = {
  heading: 'Find your dinner peace',
  firstParagraph: 'Dig into hundreds of irresistible recipes that come together in a flash.',
  collections: [
    'Vegetarian',
    'Vegan',
    'Gluten-free',
    'Dairy-free',
    'Healthy choices',
    'Family classics',
    'Quick and easy',
    'Global cuisines',
  ],
}

export const EFFORTLESS_HOME_COOKING = {
  header: 'Effortless Home Cooking',
  benefits: [
    'Line up a week of delicious meals in a few taps.',
    'Get step-by-step recipes and fresh ingredients delivered to your door.',
    'Have dinner on the table in as little as 10 mins.',
  ],
}

export const TRUSTPILOT_SECTION = {
  headingFirst: 'Over',
  headingSecond: '143 million meals',
  headingThird: 'cooked by Gousto lovers since 2013',
}

export const ENVIRONMENTAL_BENEFITS_HEADING = {
  headingFirst: 'Great food starts with great ingredients',
}

export const ENVIRONMENTAL_BENEFITS_BULLET_ONE = {
  firstLine: 'We pack our boxes with',
  secondLine: 'hand-selected seasonal produce',
  thirdLine: 'whenever possible',
}

export const ENVIRONMENTAL_BENEFITS_BULLET_TWO = {
  firstLine: '100% British',
  secondLine: 'fresh meat from trusted',
  thirdLine: 'UK farms',
}

export const ENVIRONMENTAL_BENEFITS_BULLET_THREE_WITH_URL = {
  firstLine: 'Proud to be a',
  secondLine: 'B Corp™',
  thirdLine: 'using business as a force for good.',
  fourthLine: "It's something that sets us apart from the supermarkets.",
  url: 'https://www.gousto.co.uk/blog/sustainability',
}

export const ENVIRONMENTAL_BENEFITS_DONATION_COPY = {
  firstLine: 'In 2022, we donated',
  secondLine: '970,000+ meals',
  thirdLine: 'worth of food to those in need',
}

export const VALUE_YOU_CAN_TASTE = {
  videoURL: ' https://production-media.gousto.co.uk/videos/hp-video-550px.mp4',
}
